import React, { FC, useState } from "react";
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useForm } from "react-hook-form";
import { useSendPasswordResetEmail } from "react-firebase-hooks/auth";
import { auth } from "../../firebase/config";

export interface PageRecoverPasswordProps {
  className?: string;
}

interface IRecoverPasswordForm {
  email: '',
}

const PageRecoverPassword: FC<PageRecoverPasswordProps> = ({ className = "" }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [sendPasswordResetEmail] = useSendPasswordResetEmail(auth);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmitForm = async (data: IRecoverPasswordForm) => {
    await sendPasswordResetEmail(data.email, { url: "http://localhost:3000/login" });
    setEmailSent(true);
  };

  return (
    <div className={`nc-forgot-password  ${className}`} data-nc-id="forgot-password">
      <Helmet>
        <title>Recover Password</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Recover password
        </h2>
        <div className="max-w-md mx-auto space-y-6 ">
          {/* FORM */}
          <form className="grid grid-cols-1 gap-6" onSubmit={handleSubmit(handleSubmitForm)}>
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200">
                Email address
              </span>
              <Input
                type="email"
                placeholder="example@example.com"
                className="mt-1"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Invalid email address"
                  }
                })}
              />
              {errors.email && <span className="text-red-500 text-sm">{errors.email.message?.toString()}</span>}
            </label>
            <ButtonPrimary type="submit">Send</ButtonPrimary>
            {emailSent &&
              <span className={"text-green-500 text-sm"}>Email sent! Please check your inbox for further instructions.</span>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default PageRecoverPassword;
